module.exports = __webpack_public_path__ + "img/cs-iosclub-3.a49c7714.jpg";